<template src="./index.html"></template>

<script>
import { format as fmtDate, parseISO } from 'date-fns'
import { ko } from 'vuejs-datepicker/dist/locale'
import { RoyaltyReportingApi, currentMonthKst } from './api.js'

export default {
  name: 'royaltyReporting',

  data() {
    return {
      ko,
      loading: false,
      saving: false,
      addingHoliday: false,
      month: currentMonthKst(),
      window: null,
      override: { open: '', close: '', note: '' },
      holidays: [],
      holidayForm: { date: '', description: '' },
    }
  },

  computed: {
    year() {
      return this.month ? this.month.slice(0, 4) : ''
    },
    // Date object for the month picker's current value (first of month).
    monthAsDate() {
      return this.month ? this.asDate(`${this.month}-01`) : null
    },
  },

  created() {
    this.reload()
  },

  methods: {
    reload() {
      this.loadWindow()
      this.loadHolidays()
    },

    sourceLabel(source) {
      return source === 'override' ? '수동' : '계산됨'
    },

    // 'YYYY-MM-DD' string -> Date (local midnight) for vuejs-datepicker.
    asDate(ymd) {
      return ymd ? parseISO(ymd) : null
    },
    // Date from vuejs-datepicker -> 'YYYY-MM-DD' string.
    toYmd(date) {
      return date ? fmtDate(date, 'yyyy-MM-dd') : ''
    },
    onMonthSelected(date) {
      if (!date) return
      this.month = fmtDate(date, 'yyyy-MM')
      this.onMonthChange()
    },

    loadWindow() {
      if (!this.month) return
      this.loading = true
      RoyaltyReportingApi.getWindow(this.month)
        .then((data) => {
          this.window = data
          this.override.open = data && data.source.open === 'override' ? data.openDate : ''
          this.override.close = data && data.source.close === 'override' ? data.closeDate : ''
          this.override.note = (data && data.override && data.override.note) || ''
        })
        .catch(() => {
          this.window = null
        })
        .finally(() => {
          this.loading = false
        })
    },

    loadHolidays() {
      if (!this.year) return
      RoyaltyReportingApi.listHolidays({ from: `${this.year}-01-01`, to: `${this.year}-12-31` })
        .then((list) => {
          this.holidays = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.holidays = []
        })
    },

    onMonthChange() {
      this.reload()
    },

    saveOverride() {
      this.saving = true
      const body = {
        month: this.month,
        override_open_date: this.override.open || null,
        override_close_date: this.override.close || null,
        note: this.override.note || null,
      }
      RoyaltyReportingApi.setOverride(body)
        .then((data) => {
          this.window = data
          this.$notify({ type: 'success', message: '수동 설정을 저장했습니다.' })
        })
        .catch((err) => {
          this.$notify({ type: 'danger', message: (err && err.message) || '저장에 실패했습니다.' })
        })
        .finally(() => {
          this.saving = false
        })
    },

    resetOverride() {
      RoyaltyReportingApi.clearOverride(this.month)
        .then(() => {
          this.$notify({ type: 'success', message: '기본값으로 초기화했습니다.' })
          this.loadWindow()
        })
        .catch((err) => {
          this.$notify({ type: 'danger', message: (err && err.message) || '초기화에 실패했습니다.' })
        })
    },

    addHoliday() {
      if (!this.holidayForm.date) {
        this.$notify({ type: 'warning', message: '날짜를 선택하세요.' })
        return
      }
      this.addingHoliday = true
      RoyaltyReportingApi.addHoliday({
        date: this.holidayForm.date,
        description: this.holidayForm.description || null,
      })
        .then(() => {
          this.$notify({ type: 'success', message: '휴일을 추가했습니다.' })
          this.holidayForm = { date: '', description: '' }
          this.loadHolidays()
          this.loadWindow()
        })
        .catch((err) => {
          this.$notify({ type: 'danger', message: (err && err.message) || '추가에 실패했습니다.' })
        })
        .finally(() => {
          this.addingHoliday = false
        })
    },

    removeHoliday(row) {
      RoyaltyReportingApi.removeHoliday(row.id)
        .then(() => {
          this.$notify({ type: 'success', message: '휴일을 삭제했습니다.' })
          this.loadHolidays()
          this.loadWindow()
        })
        .catch((err) => {
          this.$notify({ type: 'danger', message: (err && err.message) || '삭제에 실패했습니다.' })
        })
    },
  },
}
</script>

<style scoped>
/* vuejs-datepicker renders the input as a child component, so reach it with ::v-deep */
::v-deep .rr-date-input {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  background: #fff;
  outline: none;
  width: 130px;
}
::v-deep .rr-date-input:focus {
  border-color: #7367f0;
}
</style>
